import { EMPTY_STRING } from '@e-socna/empty';

const DEFAULT_PREFIX = '{{{';
const DEFAULT_SUFFIX = '}}}';

const HTML_PREFIX = '&#123;&#123;&#123;';
const HTML_SUFFIX = '&#125;&#125;&#125;';

export const unwrapExpression = (
  expression: string,
  prefix: string = DEFAULT_PREFIX,
  suffix: string = DEFAULT_SUFFIX,
): string => {
  if (!expression) {
    return expression;
  }

  // Remove the enclosing tags
  return expression.replace(
    new RegExp(`^${prefix}|${suffix}$`, 'g'),
    EMPTY_STRING,
  );
};

export const wrapExpression = (
  expression: string,
  prefix: string = DEFAULT_PREFIX,
  suffix: string = DEFAULT_SUFFIX,
): string => {
  if (!expression) {
    return expression;
  }

  // Remove any existing enclosing tags
  const cleanedExpression = unwrapExpression(expression, prefix, suffix);

  // Enclose the cleaned expression with the provided prefix and suffix
  return `${prefix}${cleanedExpression}${suffix}`;
};

export const wrapExpressionWithHtmlTags = (expression: string): string =>
  wrapExpression(expression, HTML_PREFIX, HTML_SUFFIX);
